import React, {createContext, useContext} from 'react';
import translations from '../locales/translations';
type Language = 'eng' | 'lv' | 'ru';

interface TranslationsContextType
{
    translate: (key: string) => string;
    language: Language;
    setLanguage: (lang: Language) => void;
}


const TranslationsContext = createContext<TranslationsContextType | undefined>(undefined);

export const TranslationsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) =>
{

    const [language, setLanguage] = React.useState<Language>('eng');

    const translate = (key: string) =>
    {
        const translation = translations[key]?.[language];
        return translation || key;
    };

    return (
        <TranslationsContext.Provider value={{ translate, language, setLanguage }}>
            {children}
        </TranslationsContext.Provider>
    );
};

export const useTranslation = (): TranslationsContextType => {
    const context = useContext(TranslationsContext);
    if (!context) {
        throw new Error("useLanguage must be used within a LanguageProvider");
    }
    return context;
};